// extracted by mini-css-extract-plugin
export default {"root":"list_root__WYZzr","item":"list_item__XjPH3"};